module.exports = __webpack_public_path__ + "static/media/ssg7.6ee47276.png";